// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3115c03","455":"ea958592"}[chunkId] + ".chunk.js";
};